import { Box, Flex, Icon } from '@storyofams/react-ui';
import { withStory, WithStoryProps } from '@storyofams/storyblok-toolkit';
import { GetStaticPaths, GetStaticProps, NextPage } from 'next';
import SbEditable from 'storyblok-react';

import { Container, Heading, RichText, Button, Text, Seo } from '~components';
import { enhancedStaticProps, withLayout } from '~lib';
import { Image } from '~components/common/DynamicSections/components/Image';
import { ArrowLeft } from '~components/common/Icons';

interface IntegrationDetailPageProps extends WithStoryProps {}

export const IntegrationDetailPage: NextPage<IntegrationDetailPageProps> = ({
  story,
}) => {
  return (
    <>
      <Seo story={story} />

      <SbEditable content={story?.content}>
        <Container>
          <Button
            variant="menuItem"
            width="max-content"
            to="/integrations"
            mb={3}
          >
            <Flex alignItems="center">
              <Icon icon={ArrowLeft} />
              <Text ml={1}>Back to Integrations</Text>
            </Flex>
          </Button>
          <Box borderRadius="md" overflow="hidden" maxWidth="764px">
            <Image image={story?.content?.bg} />
          </Box>
          <Box maxWidth="764px" mt="40px !important">
            <Heading variant="h1" as="h1" mb={2}>
              {story?.content?.title}
            </Heading>
            <RichText text={story?.content?.description} />
          </Box>
        </Container>
      </SbEditable>
    </>
  );
};

export default withLayout(withStory(IntegrationDetailPage));

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    fallback: 'blocking',
    paths: [],
  };
};

export const getStaticProps: GetStaticProps<IntegrationDetailPageProps> =
  enhancedStaticProps(async ({ sdk, params }) => {
    let story = null;
    let notFound = false;

    const slug = `${params.slug}`.toLowerCase();

    try {
      story = (
        await sdk.integration({
          slug: `integrations/${slug}`,
        })
      ).IntegrationpageItem;
    } catch (e) {
      notFound = true;
    }

    return {
      props: {
        story,
      },
      notFound: notFound || !story,
      revalidate: 60,
    };
  });
